var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _class2, _descriptor3, _descriptor4, _dec5, _dec6, _dec7, _dec8, _class3, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../Decorators/objectArrayTrait";
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import GltfTraits from "./GltfTraits";
import UrlTraits from "./UrlTraits";
export let ColorGroupTraits = (_dec = primitiveTrait({
  name: "Color",
  description: "CSS color string",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Regular Expression",
  description: "Regular expression to match on the specified property",
  type: "string"
}), _class = class ColorGroupTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "color", _descriptor, this);
    _initializerDefineProperty(this, "regExp", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "color", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "regExp", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let ColorModelsByPropertyTraits = (_dec3 = primitiveTrait({
  name: "Property",
  description: "Path to the property used to choose the color",
  type: "string"
}), _dec4 = objectArrayTrait({
  type: ColorGroupTraits,
  name: "Color Groups",
  description: "",
  idProperty: "index"
}), _class2 = class ColorModelsByPropertyTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "property", _descriptor3, this);
    _initializerDefineProperty(this, "colorGroups", _descriptor4, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "property", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "colorGroups", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
let GtfsModelTraits = (_dec5 = primitiveTrait({
  name: "Maximum draw distance",
  description: "The farthest distance from the camera that the model will still be drawn",
  type: "number"
}), _dec6 = primitiveTrait({
  name: "Maximum scale",
  description: "The maximum scale size of a model. This property is used as an upper limit for scaling due to `minimumPixelSize`",
  type: "number"
}), _dec7 = primitiveTrait({
  name: "Minimum pixel size",
  description: "The minimum pixel size of the model regardless of zoom. This can be used to ensure that a model is visible even when the viewer zooms out. When 0.0, no minimum size is enforced",
  type: "number"
}), _dec8 = objectTrait({
  name: "Color models by property",
  description: "Color entity models by reguler expression match of a property of an entity",
  type: ColorModelsByPropertyTraits
}), _class3 = class GtfsModelTraits extends mixTraits(GltfTraits, UrlTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "maximumDistance", _descriptor5, this);
    _initializerDefineProperty(this, "maximumScale", _descriptor6, this);
    _initializerDefineProperty(this, "minimumPixelSize", _descriptor7, this);
    _initializerDefineProperty(this, "colorModelsByProperty", _descriptor8, this);
  }
}, _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "maximumDistance", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "maximumScale", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "minimumPixelSize", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, "colorModelsByProperty", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3);
export { GtfsModelTraits as default };